export default __webpack_public_path__ + "static/media/link4.011dd172.jpg";